import { createVNode as i, mergeProps as n } from "vue";
import p from "../node_modules/@pf-ui/pf-icon-svg/es/asn/CopyOutlined.js";
import l from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return i(l, n(e, {
    icon: p
  }), null);
};
t.displayName = "CopyOutlined";
t.inheritAttrs = !1;
export {
  t as default
};
